import { render, staticRenderFns } from "./ExpencesCategory.vue?vue&type=template&id=9559a7ca&scoped=true"
import script from "./ExpencesCategory.vue?vue&type=script&lang=js"
export * from "./ExpencesCategory.vue?vue&type=script&lang=js"
import style0 from "./ExpencesCategory.vue?vue&type=style&index=0&id=9559a7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9559a7ca",
  null
  
)

export default component.exports